import * as React from "react"
import { Link } from 'gatsby'
import {fontFaceBarlow,fontFaceMoontime,bgStyleGray,fontColorBlue,fontColorDark,fontSizeFive} from './shared.module.scss'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import {graphql,useStaticQuery} from 'gatsby'

const McKinleyLivingBlogBlock = ()=>{

    const data = useStaticQuery(graphql`
      query {
        allContentfulBlogPost(limit: 4, sort: {fields: blogDate, order: DESC}) {
          nodes {
            id
            slug
            blogPostTitle
            blogPostExtract
            blogPostBanner {
              gatsbyImageData
            }
            blogDate(formatString: "MMMM DD, YYYY")
          }
        }
      }
    `)

    let blogPosts = [];
    data.allContentfulBlogPost.nodes.map((n)=>{
        let image = getImage(n.blogPostBanner);
        blogPosts.push({'image':image,'title':n.blogPostTitle,'extract':n.blogPostExtract,'slug':n.slug,'date':n.blogDate});
    });
    return(
        <section style={{marginTop:'8rem'}}>
            <br />
            <div className=" container">
                <div className="columns">
                    <div className="column ">
                        <h1 className={`${fontFaceMoontime} ${fontColorBlue} ${fontSizeFive}`} 
                        style={{textAlign:'center'}}><Link to="/blog">McKinley Apartment Living</Link></h1>
                    </div>
                </div>
                <br />
                <div className="columns is-padded">
                    {blogPosts.map((b)=>(
                    <div key={b.slug} className={bgStyleGray+" column is-one-quarter has-text-centered "+fontColorDark} style={{marginRight:'10px',padding:'0'}}>
                        <GatsbyImage image={b.image} alt="" style={{maxHeight:'171px',minHeight:'171px'}}/>
                        <br />
                        <br />
                        <p className={fontFaceBarlow} style={{padding:'5px'}}>{b.title}</p> 
                        <br />
                        <p className={fontFaceBarlow} style={{fontSize:'1rem'}}>{b.date}</p> 
                        <br />
                        <Link to={`/blog/post/${b.slug.trim()}/`} className="button is-link is-small">Read Article</Link>
                        <br />
                        <br />
                    </div>
                    ))}
                </div>
            </div>
            <br />
            <br />
        </section>
    )
}


export default McKinleyLivingBlogBlock
